////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const marketing = {
	postMarketing: (filters = {}, queryParams = { page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_MARKETING,
		payload: {
			filters,
			queryParams,
		},
	}),
	postMarketingSuccess: (data) => ({
		type: ActionsTypes.POST_MARKETING_SUCCESS,
		payload: {
			data,
		},
	}),
	postMarketingFailure: (error) => ({
		type: ActionsTypes.POST_MARKETING_FAILURE,
		payload: {
			error,
		},
	}),
	resetMarketing: () => ({
		type: ActionsTypes.RESET_MARKETING,
	}),
}

export default marketing
